import React from 'react';
import cn from 'classnames';
import { Button } from "../../../../ui/CTA";
import styles from './CtaList.module.scss';
const CtaList = ({ cta = [], className }) => {
    if (!(cta === null || cta === void 0 ? void 0 : cta.length))
        return null;
    return (React.createElement("ul", { className: styles.ctaList }, cta === null || cta === void 0 ? void 0 : cta.map(({ href, title, openNewTab }) => (React.createElement("li", { key: title, className: styles.ctaListItem },
        React.createElement(Button, { Tag: "a", className: cn(styles.button, className), size: "medium", href: href, rel: openNewTab && 'noopener noreferrer', target: openNewTab && '_blank' }, title))))));
};
export default CtaList;
//# sourceMappingURL=CtaList.js.map